import { render, staticRenderFns } from "./LmParcelariasNewOrEdit.vue?vue&type=template&id=02ee4572&scoped=true&"
import script from "./LmParcelariasNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmParcelariasNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmParcelariasNewOrEdit.vue?vue&type=style&index=0&id=02ee4572&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee4572",
  null
  
)

export default component.exports